// 客户端日志记录函数
import * as Sentry from '@sentry/nextjs';

const apiHeaders = {};
if (process.env.API_HOST) {
  apiHeaders.Host = process.env.API_HOST;
}

const logRequest = (type, url, data = null, result = null) => {
  const logMessage = {
    type,
    url,
    timestamp: new Date().toISOString(),
    ...(data && { data }),
    ...(result && { result }),
  };
  console.log('[Server Request]', logMessage);
};

const serverGet = (url, headers = {}) => {
  const serverSideApiUrl = process.env.NGINX_URL;
  const targetUrl = url.startsWith('http') ? url : serverSideApiUrl + url;
  return fetch(targetUrl,
    {
      method: 'GET',
      headers: {
        ...headers,
        ...apiHeaders,
        'Content-Type': 'application/json; charset=utf-8',
      },
    }).then((res) => res.json()).then(
    (result) => {
      try {
        logRequest('GET', targetUrl, null, result);
        if (!String(result?.code || result?.meta?.code).startsWith('2') && !url.includes('access-token')) {
          // 当code不是以2开头时上报错误
          Sentry.captureException(new Error(`serverGet API Error: ${JSON.stringify(result)};url: ${targetUrl};`));
        }
      } catch (e) {
        console.error(e);
      }
      return result;
    },
  ).catch((err) => {
    console.error('[Server Request] Error:', err);
  });
};

const serverPost = (url, data, headers = {}) => {
  const serverSideApiUrl = process.env.NGINX_URL;
  const targetUrl = url.startsWith('http') ? url : serverSideApiUrl + url;
  return fetch(targetUrl,
    {
      method: 'POST',
      headers: {
        ...headers,
        ...apiHeaders,
        'Content-Type': 'application/json; charset=utf-8',
      },
      body: JSON.stringify(data),
    }).then(async (res) => {
    const result = await res.json();
    try {
      logRequest('POST', targetUrl, data, result);
      if (!String(result?.code || result?.meta?.code).startsWith('2') && !url.includes('access-token')) {
        // 当code不是以2开头时上报错误
        Sentry.captureException(new Error(`serverPost API Error: ${JSON.stringify(result)};url: ${targetUrl};data: ${JSON.stringify(data)}`));
      }
    } catch (e) {
      console.error(e);
    }
    return result;
  }, (err) => {
    console.error('[Server Request] Error:', err);
  });
};

export { serverGet, serverPost };
